import { FC, lazy, LazyExoticComponent } from 'react';

const componentMap = {
    ApplicationFormPage: () =>
        import('@/pages/ApplicationFormPage/ApplicationFormPage.component'),
    AuthPage: () => import('@/pages/AuthPage/AuthPage.component'),
    AuthTgPage: () => import('@/pages/AuthTgPage/AuthTgPage.component'),
    AuthYandexPage: () =>
        import('@/pages/AuthYandexPage/AuthYandexPage.component'),
    EmptyPage: () => import('@/pages/EmptyPage/EmptyPage.component'),
    HomePage: () => import('@/pages/HomePage/HomePage.component'),
    NotFoundPage: () => import('@/pages/NotFoundPage/NotFoundPage.component'),
    OutfitsPage: () => import('@/pages/OutfitsPage/OutfitsPage.component'),
    OutfitsCreatePage: () =>
        import('@/pages/OutfitsCreatePage/OutfitsCreatePage.component'),
    OutfitsSinglePage: () =>
        import('@/pages/OutfitsSinglePage/OutfitsSinglePage.component'),
    OutfitsTinderPage: () =>
        import('@/pages/OutfitsTinderPage/OutfitsTinderPage.component'),
    PlanerPage: () => import('@/pages/PlanerPage/PlanerPage.component'),
    PlanerSingleEventPage: () =>
        import('@/pages/PlanerSingleEventPage/PlanerSingleEventPage.component'),
    PlanerAddEventPage: () =>
        import('@/pages/PlanerAddEventPage/PlanerAddEventPage.component'),
    ProfilePage: () => import('@/pages/ProfilePage/ProfilePage.component'),
    ProfileChangeEmailPage: () =>
        import('@/pages/ProfileChangeEmailPage/ProfileChangeEmailPage.component'),
    RecoveryPasswordPage: () =>
        import('@/pages/RecoveryPasswordPage/RecoveryPasswordPage.component'),
    RegistrationPage: () =>
        import('@/pages/RegistrationPage/RegistrationPage.component'),
    RootPage: () => import('@/pages/RootPage/RootPage.component'),
    SuitcasesAddPage: () =>
        import('@/pages/SuitcasesAddPage/SuitcasesAddPage.component'),
    SuitcasesPage: () =>
        import('@/pages/SuitcasesPage/SuitcasesPage.component'),
    SuitcasesSinglePage: () =>
        import('@/pages/SuitcasesSinglePage/SuitcasesSinglePage.component'),
    WardrobeAddPage: () =>
        import('@/pages/WardrobeAddPage/WardrobeAddPage.component'),
    WardrobeClothingPage: () =>
        import('@/pages/WardrobeClothingPage/WardrobeClothingPage.component'),
    WardrobeClothingSinglePage: () =>
        import('@/pages/WardrobeClothingSinglePage/WardrobeClothingSinglePage.component'),
    WardrobePage: () => import('@/pages/WardrobePage/WardrobePage.component'),
} as const;

const createLazyComponent = (
    componentName: keyof typeof componentMap,
): LazyExoticComponent<FC> =>
    lazy(() =>
        componentMap[componentName]().then((module) => ({
            default: module.default,
        })),
    );

export const LazyApplicationFormPage = createLazyComponent(
    'ApplicationFormPage',
);
export const LazyAuthTgPage = createLazyComponent('AuthTgPage');
export const AuthYandexPage = createLazyComponent('AuthYandexPage');
export const LazyAuthPage = createLazyComponent('AuthPage');
export const LazyEmptyPage = createLazyComponent('EmptyPage');
export const LazyHomePage = createLazyComponent('HomePage');
export const LazyNotFoundPage = createLazyComponent('NotFoundPage');
export const LazyOutfitsPage = createLazyComponent('OutfitsPage');
export const LazyOutfitsCreatePage = createLazyComponent('OutfitsCreatePage');
export const LazyOutfitsSinglePage = createLazyComponent('OutfitsSinglePage');
export const LazyOutfitsTinderPage = createLazyComponent('OutfitsTinderPage');
export const LazyPlanerPage = createLazyComponent('PlanerPage');
export const LazyPlanerSingleEventPage = createLazyComponent(
    'PlanerSingleEventPage',
);
export const LazyPlanerAddEventPage = createLazyComponent('PlanerAddEventPage');
export const LazyProfilePage = createLazyComponent('ProfilePage');
export const LazyProfileChangeEmailPage = createLazyComponent(
    'ProfileChangeEmailPage',
);
export const LazyRootPage = createLazyComponent('RootPage');
export const LazyRegistrationPage = createLazyComponent('RegistrationPage');
export const LazyRecoveryPasswordPage = createLazyComponent(
    'RecoveryPasswordPage',
);
export const LazySuitcasesAddPage = createLazyComponent('SuitcasesAddPage');
export const LazySuitcasesPage = createLazyComponent('SuitcasesPage');
export const LazySuitcasesSinglePage = createLazyComponent(
    'SuitcasesSinglePage',
);
export const LazyWardrobeAddPage = createLazyComponent('WardrobeAddPage');
export const LazyWardrobeClothingPage = createLazyComponent(
    'WardrobeClothingPage',
);
export const LazyWardrobeClothingSinglePage = createLazyComponent(
    'WardrobeClothingSinglePage',
);
export const LazyWardrobePage = createLazyComponent('WardrobePage');
